<template>
    <div class="phone-com-list">
        <div style="white-space: nowrap;">
            <span type="primary" class="p-container">{{ phone }}</span>
            <el-tooltip class="item" effect="dark" content="复制" placement="top"><i class="el-icon-document-copy"
                    style="margin-left:0.1rem;cursor:pointer;color:#409EFF" @click="copySome(comPhone)" v-show="copyAble === true"></i></el-tooltip>
            <el-tooltip class="item" effect="dark" content="显示手机号码" placement="top" v-if="comPhone.indexOf('**') === -1 && showAble === true"><i
                    class="el-icon-view" style="margin-left:0.1rem;cursor:pointer;color:#409EFF"
                    @click="comPhoneShow = !comPhoneShow"></i></el-tooltip>
        </div>
        <el-drawer title="" :visible.sync="phoneFromDraw" direction="rtl" :before-close="closePhoneFromDraw" size="50%" append-to-body>
            <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
                <el-row>
                    <make-phone :phone1="phoneFrom_phone"></make-phone>
                </el-row>
            </div>
        </el-drawer>
    </div>
</template>

<script>
export default {
    name: 'PhonecomList',
    props: {
        comPhone: {
            type: String
        },
        vagaryPhone: [String,Boolean],
        // clickAble: {
        //     type: Boolean,
        //     default: true
        // },
        copyAble: {
            type: Boolean,
            default: true,
        },
        showAble: {
            type: Boolean,
            default: true
        }
    },
    // components: {MakePhone},
    data() {
        return {
            comPhoneShow: false,
            phoneFromDraw: false,
            phoneFrom_phone: [],
        }
    },
    computed: {
        phone() {
            if (this.comPhoneShow) {
                return this.comPhone
            } else {
                return this.comPhone.substr(0, 5) + '****' + this.comPhone.substr(9);
            }
        }
    },
    methods: {
        // 复制功能
        copy(data) {
            // 存储传递过来的数据
            let OrderNumber = data
            // 创建一个input 元素
            // createElement() 方法通过指定名称创建一个元素
            let newInput = document.createElement('input')
            // 讲存储的数据赋值给input的value值
            newInput.value = OrderNumber
            // appendChild() 方法向节点添加最后一个子节点。
            document.body.appendChild(newInput)
            // 选中input元素中的文本
            // select() 方法用于选择该元素中的文本。
            newInput.select()
            // 执行浏览器复制命令
            //  execCommand方法是执行一个对当前文档，当前选择或者给出范围的命令
            document.execCommand('Copy')
            // 清空输入框
            newInput.remove()
            // 下面是element的弹窗 不需要的自行删除就好
            this.$message({
                message: '复制成功',
                type: 'success'
            })
        },
        copySome(data) {
            this.copy(data)
        },
        closePhoneFromDraw(done) {
            this.phoneFrom_phone = [];
            done();
        },
        openPhoneFromDraw(phone) {
            setTimeout(() => {
                this.phoneFrom_phone.push(phone);
            });
            this.phoneFromDraw = true;
        },
    }
}
</script>

<style scoped>
.p-container {
    width: 90px;
}
</style>


// WEBPACK FOOTER //
// src/common/PhonecomList.vue